import { render } from "./SizePicker.vue?vue&type=template&id=3699141e&scoped=true"
import script from "./SizePicker.vue?vue&type=script&lang=js"
export * from "./SizePicker.vue?vue&type=script&lang=js"

import "./SizePicker.vue?vue&type=style&index=0&id=3699141e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3699141e"]])

export default __exports__